import moment from 'moment';
import BaseService from '@/api/services/BaseService';

const API_RESOURCE = 'sms/conversations';

const pagination = {
  conversations: {},
  step: 100
};

export default class ConversationService extends BaseService {
  static getAll(monthsAgo = 12) {
    const since = moment().subtract(monthsAgo, 'months').format(this.apiDateTimeFormat);
    const URI = `${API_RESOURCE}/headers/${this.encodedUserId}/${encodeURI(since)}`;

    return this.getRequest(URI);
  }

  static getConversationByNumber(number, until) {
    const fromDate = moment().utc().subtract(12, 'months').format(BaseService.apiDateTimeFormat);
    const toDate = moment(until).utc().format(BaseService.apiDateTimeFormat);
    let conversationUrl = `${API_RESOURCE}/${this.encodedUserId}/${number}/${encodeURI(fromDate)}`;

    if (pagination.conversations[number] === undefined) {
      pagination.conversations[number] = 0;
    } else {
      conversationUrl += `/${encodeURI(toDate)}`;
      pagination.conversations[number] += pagination.step;
    }

    const config = {
      headers: {
        'exclude-attachments': true,
        'result-limit': `${pagination.step}:${pagination.conversations[number]}`
      }
    };

    return this.getRequest(conversationUrl, config);
  }

  static getConversationByDateRange(from, to, number) {
    const fromDate = moment(from).utc().format(BaseService.apiDateTimeFormat);
    const toDate = moment(to).utc().format(BaseService.apiDateTimeFormat);
    const conversationUrl = `${API_RESOURCE}/${this.encodedUserId}/${number}/${encodeURI(fromDate)}/${encodeURI(toDate)}`;

    const config = {
      headers: {
        'exclude-attachments': true
      }
    };

    return this.getRequest(conversationUrl, config);
  }

  static deleteConversationByConversationId(conversationId, markAsDeleted = true) {
    const conversationUrl = `${API_RESOURCE}/${this.encodedUserId}/${conversationId}?markAsDeleted=${markAsDeleted}`;

    const config = {
      headers: {
        'exclude-attachments': true
      }
    };

    return this.deleteRequestWithFullResponse(conversationUrl, config);
  }
}
